import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Body } from '@vds/typography';
import { AccordionTitle as CoreAccordionTitle } from '@vds-core/accordions';
import { colors } from '@vds/theme';

var AccordionTitle = function AccordionTitle(props) {
  return /*#__PURE__*/React.createElement(CoreAccordionTitle, _extends({}, props, {
    colorConfig: colors,
    typographyComponent: Body,
    typeSize: "large"
  }));
};

AccordionTitle.displayName = 'AccordionTitle';
export default AccordionTitle;